import { AnbModalComponent, AnbModalRef } from '@anb/ng-ui';
import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-exception-dialog',
  templateUrl: './exception-dialog.component.html',
  styleUrls: ['./exception-dialog.component.scss'],
})
export class ExceptionDialogComponent implements OnInit {
  @ViewChild('exceptionDialogModal', { static: true }) anbModalComponent: AnbModalComponent;
  protected readonly translate = inject(TranslateService);
  title: string = 'Er is iets misgelopen';
  message: string = this.translate.instant('EXCEPTION.MESSAGE');
  constructor(public modalRef: AnbModalRef<ExceptionDialogComponent, boolean>) {}

  ngOnInit() {
    if (!!this.modalRef?.data.title) {
      this.title = this.modalRef?.data.title;
    }
    if (!!this.modalRef.data.message) {
      this.message = this.modalRef.data.message;
    }
    if (typeof this.modalRef.data === 'string') {
      console.error(this.modalRef.data);
    }
  }

  close() {
    this.modalRef.close(false);
  }
}
